import { useRightDrawer } from "@/contexts/RightDrawerContext";
import { LazoUser } from "@/models/LazoUser";
import LazoAIChatDrawer from "./LazoAIChatDrawer";

type Props = { lazoUser: LazoUser };

export enum ChatsCategory {
  MY_CHATS = "MY_CHATS",
  GUEST_CHATS = "GUEST_CHATS",
}

export default function LazoAIChatRightContainerWrapper({ lazoUser }: Props) {
  const { isOpen, setIsOpen, isOnAnotherPage } = useRightDrawer();

  return <LazoAIChatDrawer lazoUser={lazoUser} open={isOpen && !isOnAnotherPage} setOpen={setIsOpen} />;
}
